  import axios              from "axios";
  import { api }            from "../_constants";
  import handleResponse     from "./handleResponse";
  import getVoucherUser     from "./handleVoucherUser";
  import getVoucherData     from "./handleVoucherData";
//import getAppStats        from "./handleAppStats";
  import getAppId           from "./handleAppId";
//import getWebServiceCount from "./handleWebServiceCount";

export const wu_TransactionFlow = {
  wu_getd2bfields,
  wu_comboValues,
  wu_validateoutbound,
  wu_sendoutbound,
  wu_validateoutbound_d2b,
  wu_sendoutbound_d2b,
  wu_checkuploadedID,
  wu_uploadcustdoc,         //SOS XXX ??? - NOT 100% READY YET
  wu_finalizeoutbound,
  wu_cardpaymentticket,
  wu_cardpaymentpay,
  wu_cardpaymentpayBP,
};
//----------------------------------------------------------------------------------------------------
function wu_getd2bfields(reqData) {
  const methName = "wu_getd2bfields ";
  const localUrl = api.url + "/wbrestservices-1.0.0/wbservice/d2b/getd2bfields?country="+reqData.country+"&transId="+reqData.transId;

  const config = {
    timeout: api.netTimeout,
    headers: {
      "Content-Type"                : "application/json",
      "Accept"                      : "application/json",
    //"username"                    : getVoucherUser(api.url),//api.username,
    //"password"                    : getVoucherData(api.url),//api.password,
      "appType"                     : api.appType,
      "appId"                       : getAppId(api.appId),//api.appId,
      "platform"                    : api.platform,
      "channel"                     : api.platformWeb,
    //"appStats"                    : getAppStats(api.webappENV),
    //"webServiceCount"             : getWebServiceCount(),
      "appVersion"                  : api.appVersion,
      "apiVersion"                  : api.apiVersion,
      "lang"                        : localStorage.getItem("lang"),
      "Access-Control-Allow-Origin" : api.allowOrigin_val,
      "tokenID"                     : localStorage.getItem("tokenID"),
      "Authorization"               : "Bearer "+ localStorage.getItem("accessToken"),
      "Cache-control"               : "no-cache, no-store, must-revalidate", //ie11 cache ajax
      "Pragma"                      : "no-cache",
      "Expires"                     : "0",
      "wbDate"                      : api.buildNumber+"/"+api.buildDateAPI,
      "wbEnv"                       : api.webappENV,
    }
  };
  if(api.use_uph){
    config.headers.username = getVoucherUser(api.url);
    config.headers.password = getVoucherData(api.url);
  }
  const data = {
    "country" : reqData.country,
    "transId" : reqData.transId
  };
  if(api.print_HTTP_URL){console.log(methName+localUrl);}
  return axios
    .post(localUrl, data, config)
    .then(handleResponse)
    .then(resData => {
      if(api.print_HTTP_RESP_BODY){console.log(resData);}
      return resData;
    })
    .catch(err => {
      console.log(methName+"err.message="+err.message);
      //-------------
      //token refresh
      //-------------
      //if(err.httpCode===401){
      if(err.message==="Request failed with status code 401"){
        const refreshUrl  = api.url + "/wbrestservices-1.0.0/wbservice/refresh";
        const refreshData = {"accessToken":localStorage.getItem("accessToken"), "refreshToken":localStorage.getItem("refreshToken") };
        return axios
          .post(refreshUrl, refreshData, config)
          .then(handleResponse)
          .then(resData => {
            if(api.print_HTTP_RESP_BODY){console.log(resData);}
            localStorage.setItem("accessToken_RetrieveLastDate", new Date());
            localStorage.setItem("accessToken",  resData.accessToken);
            config.headers["Authorization"] = "Bearer "+ localStorage.getItem("accessToken");
            //--------------
            //repeat request
            //--------------
            return axios
              .post(localUrl, data, config)
              .then(handleResponse)
              .then(resData => {
                if(api.print_HTTP_RESP_BODY){console.log(resData);}
                return resData;
              })
              .catch(err => {
                return Promise.reject(err);
              });
          })
          .catch(err => {
            return Promise.reject(err);
          });
      }
      else{
        return Promise.reject(err);
      }
    });
}
//----------------------------------------------------------------------------------------------------
function wu_comboValues(reqData) {
  const methName = "wu_comboValues ";
  const localUrl = api.url + "/wbrestservices-1.0.0/wbservice/d2b/combovalues?country="+reqData.country+"&parentTIndex="+reqData.parentTIndex;

  const config = {
    timeout: api.netTimeout,
    headers: {
      "Content-Type"                : "application/json",
      "Accept"                      : "application/json",
    //"username"                    : getVoucherUser(api.url),//api.username,
    //"password"                    : getVoucherData(api.url),//api.password,
      "appType"                     : api.appType,
      "appId"                       : getAppId(api.appId),//api.appId,
      "platform"                    : api.platform,
      "channel"                     : api.platformWeb,
    //"appStats"                    : getAppStats(api.webappENV),
    //"webServiceCount"             : getWebServiceCount(),
      "appVersion"                  : api.appVersion,
      "apiVersion"                  : api.apiVersion,
      "lang"                        : localStorage.getItem("lang"),
      "Access-Control-Allow-Origin" : api.allowOrigin_val,
      "tokenID"                     : localStorage.getItem("tokenID"),
      "Authorization"               : "Bearer "+ localStorage.getItem("accessToken"),
      "Cache-control"               : "no-cache, no-store, must-revalidate", //ie11 cache ajax
      "Pragma"                      : "no-cache",
      "Expires"                     : "0",
      "wbDate"                      : api.buildNumber+"/"+api.buildDateAPI,
      "wbEnv"                       : api.webappENV,
    }
  };
  if(api.use_uph){
    config.headers.username = getVoucherUser(api.url);
    config.headers.password = getVoucherData(api.url);
  }
  //const data = {
  //  "country" : reqData.country,
  //  "transId" : reqData.transId
  //};
  if(api.print_HTTP_URL){console.log(methName+localUrl);}
  return axios
    .get(localUrl, config)
    .then(handleResponse)
    .then(resData => {
      if(api.print_HTTP_RESP_BODY){console.log(resData);}
      return resData;
    })
    .catch(err => {
      console.log(methName+"err.message="+err.message);
      //-------------
      //token refresh
      //-------------
      //if(err.httpCode===401){
      if(err.message==="Request failed with status code 401"){
        const refreshUrl  = api.url + "/wbrestservices-1.0.0/wbservice/refresh";
        const refreshData = {"accessToken":localStorage.getItem("accessToken"), "refreshToken":localStorage.getItem("refreshToken") };
        return axios
          .post(refreshUrl, refreshData, config)
          .then(handleResponse)
          .then(resData => {
            if(api.print_HTTP_RESP_BODY){console.log(resData);}
            localStorage.setItem("accessToken_RetrieveLastDate", new Date());
            localStorage.setItem("accessToken",  resData.accessToken);
            config.headers["Authorization"] = "Bearer "+ localStorage.getItem("accessToken");
            //--------------
            //repeat request
            //--------------
            return axios
              .get(localUrl, config)
              .then(handleResponse)
              .then(resData => {
                if(api.print_HTTP_RESP_BODY){console.log(resData);}
                return resData;
              })
              .catch(err => {
                return Promise.reject(err);
              });
          })
          .catch(err => {
            return Promise.reject(err);
          });
      }
      else{
        return Promise.reject(err);
      }
    });
}
//----------------------------------------------------------------------------------------------------
function wu_validateoutbound(reqData) {
  const methName = "wu_validateoutbound ";
  const localUrl = api.url + "/wbrestservices-1.0.0/wbservice/validateoutbound";

  const config = {
    timeout: api.netTimeout,
    headers: {
      "Content-Type"                : "application/xml",
      "Accept"                      : "application/json",
    //"username"                    : getVoucherUser(api.url),//api.username,
    //"password"                    : getVoucherData(api.url),//api.password,
      "appType"                     : api.appType,
      "appId"                       : getAppId(api.appId),//api.appId,
      "platform"                    : api.platform,
      "channel"                     : api.platformWeb,
    //"appStats"                    : getAppStats(api.webappENV),
    //"webServiceCount"             : getWebServiceCount(),
      "appVersion"                  : api.appVersion,
      "apiVersion"                  : api.apiVersion,
      "lang"                        : localStorage.getItem("lang"),
      "Access-Control-Allow-Origin" : api.allowOrigin_val,
      "tokenID"                     : localStorage.getItem("tokenID"),
      "Authorization"               : "Bearer "+ localStorage.getItem("accessToken"),
      "Cache-control"               : "no-cache, no-store, must-revalidate", //ie11 cache ajax
      "Pragma"                      : "no-cache",
      "Expires"                     : "0",
      "wbDate"                      : api.buildNumber+"/"+api.buildDateAPI,
      "wbEnv"                       : api.webappENV,
    }
  };
  if(api.use_uph){
    config.headers.username = getVoucherUser(api.url);
    config.headers.password = getVoucherData(api.url);
  }
  let principal             = reqData.moneyTransferType==="0" ? reqData.principal            : "";
  let expectedActualPayout  = reqData.moneyTransferType==="1" ? reqData.expectedActualPayout : "";
  let isBehalfThirdPartyStr = api.shouldUseSMSVerify202104 ? "<behalfThirdParty>"+reqData.isBehalfThirdParty+"</behalfThirdParty>": "";
  const data = "<reqValidateOutbound>"+
                 "<idtype/>"+
                 "<idctry/>"+
                 "<idnum/>"+
                 "<idexpdate/>"+
                 "<birthDate/>"+
                 "<bankAccountNr/>"+
                 "<moneyTransferType>"+reqData.moneyTransferType+"</moneyTransferType>"+
                 "<rcv_fname>"+reqData.rcv_fname+"</rcv_fname>"+
                 "<rcv_lname>"+reqData.rcv_lname+"</rcv_lname>"+
                 "<ctry_wu_id>"+reqData.ctry_wu_id+"</ctry_wu_id>"+
                 "<state_id>"+reqData.state_id+"</state_id>"+
                 "<city>"+reqData.city+"</city>"+
                 "<snd_curr>"+reqData.snd_curr+"</snd_curr>"+
                 "<rcv_curr>"+reqData.rcv_curr+"</rcv_curr>"+
                 "<principal>"+principal+"</principal>"+
                 "<expectedActualPayout>"+expectedActualPayout+"</expectedActualPayout>"+
                 "<fxrate/>"+
                 "<quest>"+reqData.quest+"</quest>"+
                 "<answ>"+reqData.answ+"</answ>"+
                 "<requireToPayWithoutValidId>"+reqData.requireToPayWithoutValidId+"</requireToPayWithoutValidId>"+
                 "<afm>"+reqData.afm+"</afm>"+
                 "<promo_code>"+reqData.promo_code+"</promo_code>"+
                 "<delivery_service_code/>"+
                 "<usr_id/>"+
                 "<txnchannel>"+reqData.txnchannel+"</txnchannel>"+
                 "<reasonOfPayment>"+reqData.reasonOfPayment+"</reasonOfPayment>"+    //KYC Transaction - OK
                 "<srcFunds>"+reqData.srcFunds+"</srcFunds>"+                         //KYC Transaction - OK
                 "<custRelationship>"+reqData.custRelationship+"</custRelationship>"+ //KYC Transaction - OK
                 isBehalfThirdPartyStr+
               "</reqValidateOutbound>";
  if(api.print_HTTP_URL){console.log(methName+localUrl);}
  return axios
    .post(localUrl, data, config)
    .then(handleResponse)
    .then(resData => {
      if(api.print_HTTP_RESP_BODY){console.log(resData);}
      return resData;
    })
    .catch(err => {
      //-------------
      //token refresh
      //-------------
      //if(err.httpCode===401){
      if(err.message==="Request failed with status code 401"){
        const refreshUrl  = api.url + "/wbrestservices-1.0.0/wbservice/refresh";
        const refreshData = {"accessToken":localStorage.getItem("accessToken"), "refreshToken":localStorage.getItem("refreshToken") };
        return axios
          .post(refreshUrl, refreshData, config)
          .then(handleResponse)
          .then(resData => {
            if(api.print_HTTP_RESP_BODY){console.log(resData);}
            localStorage.setItem("accessToken_RetrieveLastDate", new Date());
            localStorage.setItem("accessToken",  resData.accessToken);
            config.headers["Authorization"] = "Bearer "+ localStorage.getItem("accessToken");
            //--------------
            //repeat request
            //--------------
            return axios
              .post(localUrl, data, config)
              .then(handleResponse)
              .then(resData => {
                if(api.print_HTTP_RESP_BODY){console.log(resData);}
                return resData;
              })
              .catch(err => {
                return Promise.reject(err);
              });
          })
          .catch(err => {
            return Promise.reject(err);
          });
      }
      else{
        return Promise.reject(err);
      }
    });
}
//----------------------------------------------------------------------------------------------------
function wu_sendoutbound(reqData,countryCode) {
  const methName = "wu_sendoutbound ";
  const localUrl = api.url + "/wbrestservices-1.0.0/wbservice/sendoutbound?country="+countryCode;

  const config = {
    timeout: api.netTimeout,
    headers: {
      "Content-Type"                : "application/xml",
      "Accept"                      : "application/json",
    //"username"                    : getVoucherUser(api.url),//api.username,
    //"password"                    : getVoucherData(api.url),//api.password,
      "appType"                     : api.appType,
      "appId"                       : getAppId(api.appId),//api.appId,
      "platform"                    : api.platform,
      "channel"                     : api.platformWeb,
    //"appStats"                    : getAppStats(api.webappENV),
    //"webServiceCount"             : getWebServiceCount(),
      "appVersion"                  : api.appVersion,
      "apiVersion"                  : api.apiVersion,
      "lang"                        : localStorage.getItem("lang"),
      "Access-Control-Allow-Origin" : api.allowOrigin_val,
      "tokenID"                     : localStorage.getItem("tokenID"),
      "Authorization"               : "Bearer "+ localStorage.getItem("accessToken"),
      "Cache-control"               : "no-cache, no-store, must-revalidate", //ie11 cache ajax
      "Pragma"                      : "no-cache",
      "Expires"                     : "0",
      "wbDate"                      : api.buildNumber+"/"+api.buildDateAPI,
      "wbEnv"                       : api.webappENV,
    }
  };
  if(api.use_uph){
    config.headers.username = getVoucherUser(api.url);
    config.headers.password = getVoucherData(api.url);
  }
  let principal             = reqData.moneyTransferType==="0" ? reqData.principal            : "";
  let expectedActualPayout  = reqData.moneyTransferType==="1" ? reqData.expectedActualPayout : "";
  let isBehalfThirdPartyStr = api.shouldUseSMSVerify202104 ? "<behalfThirdParty>"+reqData.isBehalfThirdParty+"</behalfThirdParty>": "";
  const data = "<reqValidateOutbound>"+
                 "<idtype/>"+
                 "<idctry/>"+
                 "<idnum>"+reqData.idnum+"</idnum>"+
                 "<idexpdate/>"+
                 "<birthDate>"+reqData.birthDate+"</birthDate>"+
                 "<bankAccountNr/>"+
                 "<moneyTransferType>"+reqData.moneyTransferType+"</moneyTransferType>"+
                 "<rcv_fname>"+reqData.rcv_fname+"</rcv_fname>"+
                 "<rcv_lname>"+reqData.rcv_lname+"</rcv_lname>"+
                 "<ctry_wu_id>"+reqData.ctry_wu_id+"</ctry_wu_id>"+
                 "<state_id>"+reqData.state_id+"</state_id>"+
                 "<city>"+reqData.city+"</city>"+
                 "<snd_curr>"+reqData.snd_curr+"</snd_curr>"+
                 "<rcv_curr>"+reqData.rcv_curr+"</rcv_curr>"+
                 "<principal>"+principal+"</principal>"+
                 "<expectedActualPayout>"+expectedActualPayout+"</expectedActualPayout>"+
                 "<fxrate/>"+
                 "<quest>"+reqData.quest+"</quest>"+
                 "<answ>"+reqData.answ+"</answ>"+
                 "<requireToPayWithoutValidId>"+reqData.requireToPayWithoutValidId+"</requireToPayWithoutValidId>"+
                 "<afm>"+reqData.afm+"</afm>"+
                 "<promo_code>"+reqData.promo_code+"</promo_code>"+
                 "<pin_code>"+reqData.pin_code+"</pin_code>"+
                 "<delivery_service_code/>"+
                 "<usr_id/>"+
                 "<txnchannel>"+reqData.txnchannel+"</txnchannel>"+
                 "<reasonOfPayment>"+reqData.reasonOfPayment+"</reasonOfPayment>"+    //KYC-2.1 Transaction
                 "<srcFunds>"+reqData.srcFunds+"</srcFunds>"+                         //KYC Transaction - OK
                 "<custRelationship>"+reqData.custRelationship+"</custRelationship>"+ //KYC Transaction - OK
                 isBehalfThirdPartyStr+
                 "<wantSmsNotification>"+reqData.wantSmsNotification+"</wantSmsNotification>"+
                 "<idissuedate/>"+
               "</reqValidateOutbound>";
  if(api.print_HTTP_URL){console.log(methName+localUrl);}
  return axios
    .post(localUrl, data, config)
    .then(handleResponse)
    .then(resData => {
      if(api.print_HTTP_RESP_BODY){console.log(resData);}
      return resData;
    })
    .catch(err => {
      //-------------
      //token refresh
      //-------------
      //if(err.httpCode===401){
      if(err.message==="Request failed with status code 401"){
        const refreshUrl  = api.url + "/wbrestservices-1.0.0/wbservice/refresh";
        const refreshData = {"accessToken":localStorage.getItem("accessToken"), "refreshToken":localStorage.getItem("refreshToken") };
        return axios
          .post(refreshUrl, refreshData, config)
          .then(handleResponse)
          .then(resData => {
            if(api.print_HTTP_RESP_BODY){console.log(resData);}
            localStorage.setItem("accessToken_RetrieveLastDate", new Date());
            localStorage.setItem("accessToken",  resData.accessToken);
            config.headers["Authorization"] = "Bearer "+ localStorage.getItem("accessToken");
            //--------------
            //repeat request
            //--------------
            return axios
              .post(localUrl, data, config)
              .then(handleResponse)
              .then(resData => {
                if(api.print_HTTP_RESP_BODY){console.log(resData);}
                return resData;
              })
              .catch(err => {
                return Promise.reject(err);
              });
          })
          .catch(err => {
            return Promise.reject(err);
          });
      }
      else{
        return Promise.reject(err);
      }
    });
}
//----------------------------------------------------------------------------------------------------
function wu_validateoutbound_d2b(reqData) {
  const methName = "wu_validateoutbound_d2b ";
  const localUrl = api.url + "/wbrestservices-1.0.0/wbservice/d2b/validateoutbound";

  const config = {
    timeout: api.netTimeout,
    headers: {
      "Content-Type"                : "application/xml",
      "Accept"                      : "application/json",
    //"username"                    : getVoucherUser(api.url),//api.username,
    //"password"                    : getVoucherData(api.url),//api.password,
      "appType"                     : api.appType,
      "appId"                       : getAppId(api.appId),//api.appId,
      "platform"                    : api.platform,
      "channel"                     : api.platformWeb,
    //"appStats"                    : getAppStats(api.webappENV),
    //"webServiceCount"             : getWebServiceCount(),
      "appVersion"                  : api.appVersion,
      "apiVersion"                  : api.apiVersion,
      "lang"                        : localStorage.getItem("lang"),
      "Access-Control-Allow-Origin" : api.allowOrigin_val,
      "tokenID"                     : localStorage.getItem("tokenID"),
      "Authorization"               : "Bearer "+ localStorage.getItem("accessToken"),
      "Cache-control"               : "no-cache, no-store, must-revalidate", //ie11 cache ajax
      "Pragma"                      : "no-cache",
      "Expires"                     : "0",
      "wbDate"                      : api.buildNumber+"/"+api.buildDateAPI,
      "wbEnv"                       : api.webappENV,
    }
  };
  if(api.use_uph){
    config.headers.username = getVoucherUser(api.url);
    config.headers.password = getVoucherData(api.url);
  }
  let principal             = reqData.moneyTransferType==="0" ? reqData.principal            : "";
  let expectedActualPayout  = reqData.moneyTransferType==="1" ? reqData.expectedActualPayout : "";
  let isBehalfThirdPartyStr = api.shouldUseSMSVerify202104 ? "<behalfThirdParty>"+reqData.isBehalfThirdParty+"</behalfThirdParty>": "";
  const data = "<reqValidateOutbound>"+
                 "<idtype/>"+
                 "<idctry/>"+
                 "<idnum/>"+
                 "<idexpdate/>"+
                 "<birthDate/>"+
                 "<bankAccountNr/>"+
                 "<moneyTransferType>"+reqData.moneyTransferType+"</moneyTransferType>"+
                 "<rcv_fname>"+reqData.rcv_fname+"</rcv_fname>"+
                 "<rcv_lname>"+reqData.rcv_lname+"</rcv_lname>"+
                 "<ctry_wu_id>"+reqData.ctry_wu_id+"</ctry_wu_id>"+
                 "<state_id>"+reqData.state_id+"</state_id>"+
                 "<city>"+reqData.city+"</city>"+
                 "<snd_curr>"+reqData.snd_curr+"</snd_curr>"+
                 "<rcv_curr>"+reqData.rcv_curr+"</rcv_curr>"+
                 "<principal>"+principal+"</principal>"+
                 "<expectedActualPayout>"+expectedActualPayout+"</expectedActualPayout>"+
                 "<fxrate/>"+
                 "<quest>"+reqData.quest+"</quest>"+
                 "<answ>"+reqData.answ+"</answ>"+
                 "<requireToPayWithoutValidId>"+reqData.requireToPayWithoutValidId+"</requireToPayWithoutValidId>"+
                 "<afm>"+reqData.afm+"</afm>"+
                 "<promo_code>"+reqData.promo_code+"</promo_code>"+
                 "<delivery_service_code/>"+
                 "<usr_id/>"+
                 "<txnchannel>"+reqData.txnchannel+"</txnchannel>"+
                 "<reasonOfPayment>"+reqData.reasonOfPayment+"</reasonOfPayment>"+    //KYC Transaction - OK
                 "<srcFunds>"+reqData.srcFunds+"</srcFunds>"+                         //KYC Transaction - OK
                 "<custRelationship>"+reqData.custRelationship+"</custRelationship>"+ //KYC Transaction - OK
                 isBehalfThirdPartyStr+
                 ""+reqData.D2BField_xml+""+
              "</reqValidateOutbound>";
  if(api.print_HTTP_URL){console.log(methName+localUrl);}
  return axios
    .post(localUrl, data, config)
    .then(handleResponse)
    .then(resData => {
      if(api.print_HTTP_RESP_BODY){console.log(resData);}
      return resData;
    })
    .catch(err => {
      //-------------
      //token refresh
      //-------------
      //if(err.httpCode===401){
      if(err.message==="Request failed with status code 401"){
        const refreshUrl  = api.url + "/wbrestservices-1.0.0/wbservice/refresh";
        const refreshData = {"accessToken":localStorage.getItem("accessToken"), "refreshToken":localStorage.getItem("refreshToken") };
        return axios
          .post(refreshUrl, refreshData, config)
          .then(handleResponse)
          .then(resData => {
            if(api.print_HTTP_RESP_BODY){console.log(resData);}
            localStorage.setItem("accessToken_RetrieveLastDate", new Date());
            localStorage.setItem("accessToken",  resData.accessToken);
            config.headers["Authorization"] = "Bearer "+ localStorage.getItem("accessToken");
            //--------------
            //repeat request
            //--------------
            return axios
              .post(localUrl, data, config)
              .then(handleResponse)
              .then(resData => {
                if(api.print_HTTP_RESP_BODY){console.log(resData);}
                return resData;
              })
              .catch(err => {
                return Promise.reject(err);
              });
          })
          .catch(err => {
            return Promise.reject(err);
          });
      }
      else{
        return Promise.reject(err);
      }
    });
}
//----------------------------------------------------------------------------------------------------
function wu_sendoutbound_d2b(reqData,countryCode) {
  const methName = "wu_sendoutbound_d2b ";
  const localUrl = api.url + "/wbrestservices-1.0.0/wbservice/d2b/sendoutbound?country="+countryCode;

  const config = {
    timeout: api.netTimeout,
    headers: {
      "Content-Type"                : "application/xml",
      "Accept"                      : "application/json",
    //"username"                    : getVoucherUser(api.url),//api.username,
    //"password"                    : getVoucherData(api.url),//api.password,
      "appType"                     : api.appType,
      "appId"                       : getAppId(api.appId),//api.appId,
      "platform"                    : api.platform,
      "channel"                     : api.platformWeb,
    //"appStats"                    : getAppStats(api.webappENV),
    //"webServiceCount"             : getWebServiceCount(),
      "appVersion"                  : api.appVersion,
      "apiVersion"                  : api.apiVersion,
      "lang"                        : localStorage.getItem("lang"),
      "Access-Control-Allow-Origin" : api.allowOrigin_val,
      "tokenID"                     : localStorage.getItem("tokenID"),
      "Authorization"               : "Bearer "+ localStorage.getItem("accessToken"),
      "Cache-control"               : "no-cache, no-store, must-revalidate", //ie11 cache ajax
      "Pragma"                      : "no-cache",
      "Expires"                     : "0",
      "wbDate"                      : api.buildNumber+"/"+api.buildDateAPI,
      "wbEnv"                       : api.webappENV,
    }
  };
  if(api.use_uph){
    config.headers.username = getVoucherUser(api.url);
    config.headers.password = getVoucherData(api.url);
  }
  let principal             = reqData.moneyTransferType==="0" ? reqData.principal            : "";
  let expectedActualPayout  = reqData.moneyTransferType==="1" ? reqData.expectedActualPayout : "";
  let isBehalfThirdPartyStr = api.shouldUseSMSVerify202104 ? "<behalfThirdParty>"+reqData.isBehalfThirdParty+"</behalfThirdParty>": "";
  const data = "<reqValidateOutbound>"+
                 "<idtype/>"+
                 "<idctry/>"+
                 "<idnum>"+reqData.idnum+"</idnum>"+
                 "<idexpdate/>"+
                 "<birthDate/>"+
                 "<bankAccountNr/>"+
                 "<moneyTransferType>"+reqData.moneyTransferType+"</moneyTransferType>"+
                 "<rcv_fname>"+reqData.rcv_fname+"</rcv_fname>"+
                 "<rcv_lname>"+reqData.rcv_lname+"</rcv_lname>"+
                 "<ctry_wu_id>"+reqData.ctry_wu_id+"</ctry_wu_id>"+
                 "<state_id>"+reqData.state_id+"</state_id>"+
                 "<city>"+reqData.city+"</city>"+
                 "<snd_curr>"+reqData.snd_curr+"</snd_curr>"+
                 "<rcv_curr>"+reqData.rcv_curr+"</rcv_curr>"+
                 "<principal>"+principal+"</principal>"+
                 "<expectedActualPayout>"+expectedActualPayout+"</expectedActualPayout>"+
                 "<fxrate/>"+
                 "<quest>"+reqData.quest+"</quest>"+
                 "<answ>"+reqData.answ+"</answ>"+
                 "<requireToPayWithoutValidId>"+reqData.requireToPayWithoutValidId+"</requireToPayWithoutValidId>"+
                 "<afm>"+reqData.afm+"</afm>"+
                 "<promo_code>"+reqData.promo_code+"</promo_code>"+
                 "<pin_code>"+reqData.pin_code+"</pin_code>"+
                 "<delivery_service_code/>"+
                 "<usr_id/>"+
                 "<txnchannel>"+reqData.txnchannel+"</txnchannel>"+
                 "<reasonOfPayment>"+reqData.reasonOfPayment+"</reasonOfPayment>"+    //KYC-2.1 Transaction
                 "<srcFunds>"+reqData.srcFunds+"</srcFunds>"+                         //KYC Transaction - OK
                 "<custRelationship>"+reqData.custRelationship+"</custRelationship>"+ //KYC Transaction - OK
                 isBehalfThirdPartyStr+
                 "<wantSmsNotification>"+reqData.wantSmsNotification+"</wantSmsNotification>"+
                 ""+reqData.D2BField_xml+""+
                 "<idissuedate/>"+
                "</reqValidateOutbound>";
  if(api.print_HTTP_URL){console.log(methName+localUrl);}
  return axios
    .post(localUrl, data, config)
    .then(handleResponse)
    .then(resData => {
      if(api.print_HTTP_RESP_BODY){console.log(resData);}
      return resData;
    })
    .catch(err => {
      //-------------
      //token refresh
      //-------------
      //if(err.httpCode===401){
      if(err.message==="Request failed with status code 401"){
        const refreshUrl  = api.url + "/wbrestservices-1.0.0/wbservice/refresh";
        const refreshData = {"accessToken":localStorage.getItem("accessToken"), "refreshToken":localStorage.getItem("refreshToken") };
        return axios
          .post(refreshUrl, refreshData, config)
          .then(handleResponse)
          .then(resData => {
            if(api.print_HTTP_RESP_BODY){console.log(resData);}
            localStorage.setItem("accessToken_RetrieveLastDate", new Date());
            localStorage.setItem("accessToken",  resData.accessToken);
            config.headers["Authorization"] = "Bearer "+ localStorage.getItem("accessToken");
            //--------------
            //repeat request
            //--------------
            return axios
              .post(localUrl, data, config)
              .then(handleResponse)
              .then(resData => {
                if(api.print_HTTP_RESP_BODY){console.log(resData);}
                return resData;
              })
              .catch(err => {
                return Promise.reject(err);
              });
          })
          .catch(err => {
            return Promise.reject(err);
          });
      }
      else{
        return Promise.reject(err);
      }
    });
}
//----------------------------------------------------------------------------------------------------
function wu_checkuploadedID(reqData) {
  const methName = "wu_checkuploadedID ";
  const localUrl = api.url + "/wbrestservices-1.0.0/wbservice/checkuploadedID?idnum="+reqData.idnum+"&idtype="+reqData.idtype+"&idctry="+reqData.idctry+"&firstName="+reqData.firstName+"&lastName="+reqData.lastName;

  const config = {
    timeout: api.netTimeout,
    headers: {
      "Content-Type"                : "application/json",
      "Accept"                      : "application/json",
    //"username"                    : getVoucherUser(api.url),//api.username,
    //"password"                    : getVoucherData(api.url),//api.password,
      "appType"                     : api.appType,
      "appId"                       : getAppId(api.appId),//api.appId,
      "platform"                    : api.platform,
      "channel"                     : api.platformWeb,
    //"appStats"                    : getAppStats(api.webappENV),
    //"webServiceCount"             : getWebServiceCount(),
      "appVersion"                  : api.appVersion,
      "apiVersion"                  : api.apiVersion,
      "lang"                        : localStorage.getItem("lang"),
      "Access-Control-Allow-Origin" : api.allowOrigin_val,
      "tokenID"                     : localStorage.getItem("tokenID"),
      "Authorization"               : "Bearer "+ localStorage.getItem("accessToken"),
      "Cache-control"               : "no-cache, no-store, must-revalidate", //ie11 cache ajax
      "Pragma"                      : "no-cache",
      "Expires"                     : "0",
      "wbDate"                      : api.buildNumber+"/"+api.buildDateAPI,
      "wbEnv"                       : api.webappENV,
    }
  };
  if(api.use_uph){
    config.headers.username = getVoucherUser(api.url);
    config.headers.password = getVoucherData(api.url);
  }
  const data = {
    "snd_curr"  : "EUR",
    "principal" : "10.00"
  };
  if(api.print_HTTP_URL){console.log(methName+localUrl);}
  return axios
    .post(localUrl, data, config)
    .then(handleResponse)
    .then(resData => {
      if(api.print_HTTP_RESP_BODY){console.log(resData);}
      return resData;
    })
    .catch(err => {
      //-------------
      //token refresh
      //-------------
      //if(err.httpCode===401){
      if(err.message==="Request failed with status code 401"){
        const refreshUrl  = api.url + "/wbrestservices-1.0.0/wbservice/refresh";
        const refreshData = {"accessToken":localStorage.getItem("accessToken"), "refreshToken":localStorage.getItem("refreshToken") };
        return axios
          .post(refreshUrl, refreshData, config)
          .then(handleResponse)
          .then(resData => {
            if(api.print_HTTP_RESP_BODY){console.log(resData);}
            localStorage.setItem("accessToken_RetrieveLastDate", new Date());
            localStorage.setItem("accessToken",  resData.accessToken);
            config.headers["Authorization"] = "Bearer "+ localStorage.getItem("accessToken");
            //--------------
            //repeat request
            //--------------
            return axios
              .post(localUrl, data, config)
              .then(handleResponse)
              .then(resData => {
                if(api.print_HTTP_RESP_BODY){console.log(resData);}
                return resData;
              })
              .catch(err => {
                return Promise.reject(err);
              });
          })
          .catch(err => {
            return Promise.reject(err);
          });
      }
      else{
        return Promise.reject(err);
      }
    });
}
//----------------------------------------------------------------------------------------------------
function wu_uploadcustdoc(reqData) {
  const methName = "wu_uploadcustdoc ";
  const localUrl = api.url + "/wbrestservices-1.0.0/wbservice/d2b/uploadcustdoc";

  const config = {
    timeout: api.netTimeout,
    headers: {
      "Content-Type"                : "application/json",
      "Accept"                      : "application/json",
    //"username"                    : getVoucherUser(api.url),//api.username,
    //"password"                    : getVoucherData(api.url),//api.password,
      "appType"                     : api.appType,
      "appId"                       : getAppId(api.appId),//api.appId,
      "platform"                    : api.platform,
      "channel"                     : api.platformWeb,
    //"appStats"                    : getAppStats(api.webappENV),
    //"webServiceCount"             : getWebServiceCount(),
      "appVersion"                  : api.appVersion,
      "apiVersion"                  : api.apiVersion,
      "lang"                        : localStorage.getItem("lang"),
      "Access-Control-Allow-Origin" : api.allowOrigin_val,
      "tokenID"                     : localStorage.getItem("tokenID"),
      "Authorization"               : "Bearer "+ localStorage.getItem("accessToken"),
      "Cache-control"               : "no-cache, no-store, must-revalidate", //ie11 cache ajax
      "Pragma"                      : "no-cache",
      "Expires"                     : "0",
      "wbDate"                      : api.buildNumber+"/"+api.buildDateAPI,
      "wbEnv"                       : api.webappENV,
    }
  };
  if(api.use_uph){
    config.headers.username = getVoucherUser(api.url);
    config.headers.password = getVoucherData(api.url);
  }
  const data = {

  };
  if(api.print_HTTP_URL){console.log(methName+localUrl);}
  return axios
    .post(localUrl, data, config)
    .then(handleResponse)
    .then(resData => {
      if(api.print_HTTP_RESP_BODY){console.log(resData);}
      return resData;
    })
    .catch(err => {
      //-------------
      //token refresh
      //-------------
      //if(err.httpCode===401){
      if(err.message==="Request failed with status code 401"){
        const refreshUrl  = api.url + "/wbrestservices-1.0.0/wbservice/refresh";
        const refreshData = {"accessToken":localStorage.getItem("accessToken"), "refreshToken":localStorage.getItem("refreshToken") };
        return axios
          .post(refreshUrl, refreshData, config)
          .then(handleResponse)
          .then(resData => {
            if(api.print_HTTP_RESP_BODY){console.log(resData);}
            localStorage.setItem("accessToken_RetrieveLastDate", new Date());
            localStorage.setItem("accessToken",  resData.accessToken);
            config.headers["Authorization"] = "Bearer "+ localStorage.getItem("accessToken");
            //--------------
            //repeat request
            //--------------
            return axios
              .post(localUrl, data, config)
              .then(handleResponse)
              .then(resData => {
                if(api.print_HTTP_RESP_BODY){console.log(resData);}
                return resData;
              })
              .catch(err => {
                return Promise.reject(err);
              });
          })
          .catch(err => {
            return Promise.reject(err);
          });
      }
      else{
        return Promise.reject(err);
      }
    });
}
//----------------------------------------------------------------------------------------------------
function wu_finalizeoutbound(reqData) {
  const methName = "wu_finalizeoutbound ";
  const localUrl = api.url + "/wbrestservices-1.0.0/wbservice/finalizeoutbound?country=GR";

  const config = {
    timeout: api.netTimeout,
    headers: {
      "Content-Type"                : "application/xml",
      "Accept"                      : "application/json",
    //"username"                    : getVoucherUser(api.url),//api.username,
    //"password"                    : getVoucherData(api.url),//api.password,
      "appType"                     : api.appType,
      "appId"                       : getAppId(api.appId),//api.appId,
      "platform"                    : api.platform,
      "channel"                     : api.platformWeb,
    //"appStats"                    : getAppStats(api.webappENV),
    //"webServiceCount"             : getWebServiceCount(),
      "appVersion"                  : api.appVersion,
      "apiVersion"                  : api.apiVersion,
      "lang"                        : localStorage.getItem("lang"),
      "Access-Control-Allow-Origin" : api.allowOrigin_val,
      "tokenID"                     : localStorage.getItem("tokenID"),
      "Authorization"               : "Bearer "+ localStorage.getItem("accessToken"),
      "Cache-control"               : "no-cache, no-store, must-revalidate", //ie11 cache ajax
      "Pragma"                      : "no-cache",
      "Expires"                     : "0",
      "wbDate"                      : api.buildNumber+"/"+api.buildDateAPI,
      "wbEnv"                       : api.webappENV,
    }
  };
  if(api.use_uph){
    config.headers.username = getVoucherUser(api.url);
    config.headers.password = getVoucherData(api.url);
  }
  let data = "";
  if(reqData.finalizeoutbound_type==="finalizeoutbound_type_CreditCard_success"){
    data = "<?xml version=\"1.0\" encoding=\"UTF-8\"?>"+
    "<reqFinalizeOutbound>"+
       "<usr_id/>"+
       "<sa_id/>"+
    //"<wantMktInfo>"+reqData.wantMktInfo+"</wantMktInfo>"+
       "<centralID>"+reqData.centralID+"</centralID>"+
       "<status/>"+
       "<credit_indicator/>"+
       "<isSofort>"+reqData.isSofort+"</isSofort>"+

       "<transactionId>"+reqData.transactionId+"</transactionId>"+
       "<supportReferenceID>"+reqData.supportReferenceID+"</supportReferenceID>"+
       "<approvalCode>"+reqData.approvalCode+"</approvalCode>"+
       "<packageNo>"+reqData.packageNo+"</packageNo>"+
       "<responseCode>"+reqData.responseCode+"</responseCode>"+
       "<retrievalRef>"+reqData.retrievalRef+"</retrievalRef>"+
       "<resultCode>"+reqData.resultCode+"</resultCode>"+

       "<resultDescription>"+reqData.resultDescription+"</resultDescription>"+
       "<statusFlag>"+reqData.statusFlag+"</statusFlag>"+
       "<responseDescription>"+reqData.responseDescription+"</responseDescription>"+
       "<merchantRef>"+reqData.merchantRef+"</merchantRef>"+
       "<transDatetime>"+reqData.transDatetime+"</transDatetime>"+

    "</reqFinalizeOutbound>";
  }
  else if(reqData.finalizeoutbound_type==="finalizeoutbound_type_CreditCard_failure"){
    data = "<?xml version=\"1.0\" encoding=\"UTF-8\"?>"+
    "<reqFinalizeOutbound>"+
       "<usr_id/>"+
       "<sa_id/>"+
    //"<wantMktInfo>"+reqData.wantMktInfo+"</wantMktInfo>"+
       "<centralID>"+reqData.centralID+"</centralID>"+
       "<status/>"+
       "<credit_indicator/>"+
       "<isSofort>"+reqData.isSofort+"</isSofort>"+

       "<transactionId>"+reqData.transactionId+"</transactionId>"+
       "<supportReferenceID>"+reqData.supportReferenceID+"</supportReferenceID>"+
       "<approvalCode>"+reqData.approvalCode+"</approvalCode>"+
       "<packageNo>"+reqData.packageNo+"</packageNo>"+
       "<responseCode>"+reqData.responseCode+"</responseCode>"+
       "<retrievalRef>"+reqData.retrievalRef+"</retrievalRef>"+
       "<resultCode>"+reqData.resultCode+"</resultCode>"+

       "<resultDescription>"+reqData.resultDescription+"</resultDescription>"+
       "<statusFlag>"+reqData.statusFlag+"</statusFlag>"+
       "<responseDescription>"+reqData.responseDescription+"</responseDescription>"+
       "<merchantRef>"+reqData.merchantRef+"</merchantRef>"+
       "<transDatetime>"+reqData.transDatetime+"</transDatetime>"+

    "</reqFinalizeOutbound>";
  }
  else{
    data = "<?xml version=\"1.0\" encoding=\"UTF-8\"?>"+
    "<reqFinalizeOutbound>"+
       "<usr_id/>"+
       "<sa_id/>"+
    //"<wantMktInfo>"+reqData.wantMktInfo+"</wantMktInfo>"+
       "<centralID>"+reqData.centralID+"</centralID>"+
       "<status/>"+
       "<credit_indicator/>"+
       "<isSofort>"+reqData.isSofort+"</isSofort>"+
    "</reqFinalizeOutbound>";
  }
  if(api.print_HTTP_URL){console.log(methName+localUrl);}
  return axios
    .post(localUrl, data, config)
    .then(handleResponse)
    .then(resData => {
      if(api.print_HTTP_RESP_BODY){console.log(resData);}
      return resData;
    })
    .catch(err => {
      //-------------
      //token refresh
      //-------------
      //if(err.httpCode===401){
      if(err.message==="Request failed with status code 401"){
        const refreshUrl  = api.url + "/wbrestservices-1.0.0/wbservice/refresh";
        const refreshData = {"accessToken":localStorage.getItem("accessToken"), "refreshToken":localStorage.getItem("refreshToken") };
        return axios
          .post(refreshUrl, refreshData, config)
          .then(handleResponse)
          .then(resData => {
            if(api.print_HTTP_RESP_BODY){console.log(resData);}
            localStorage.setItem("accessToken_RetrieveLastDate", new Date());
            localStorage.setItem("accessToken",  resData.accessToken);
            config.headers["Authorization"] = "Bearer "+ localStorage.getItem("accessToken");
            //--------------
            //repeat request
            //--------------
            return axios
              .post(localUrl, data, config)
              .then(handleResponse)
              .then(resData => {
                if(api.print_HTTP_RESP_BODY){console.log(resData);}
                return resData;
              })
              .catch(err => {
                return Promise.reject(err);
              });
          })
          .catch(err => {
            return Promise.reject(err);
          });
      }
      else{
        return Promise.reject(err);
      }
    });
}
//----------------------------------------------------------------------------------------------------
function wu_cardpaymentticket(reqData) {
  const methName = "wu_cardpaymentticket ";
  const localUrl = api.url + "/wbrestservices-1.0.0/wbservice/cardpaymentticket";

  const config = {
    timeout: api.netTimeout,
    headers: {
      "Content-Type"                : "application/json",//"application/xml",
      "Accept"                      : "application/json",
    //"username"                    : getVoucherUser(api.url),//api.username,
    //"password"                    : getVoucherData(api.url),//api.password,
      "appType"                     : api.appType,
      "appId"                       : getAppId(api.appId),//api.appId,
      "platform"                    : api.platform,
      "channel"                     : api.platformWeb,
    //"appStats"                    : getAppStats(api.webappENV),
    //"webServiceCount"             : getWebServiceCount(),
      "appVersion"                  : api.appVersion,
      "apiVersion"                  : api.apiVersion,
      "lang"                        : localStorage.getItem("lang"),
      "Access-Control-Allow-Origin" : api.allowOrigin_val,
      "tokenID"                     : localStorage.getItem("tokenID"),
      "Authorization"               : "Bearer "+ localStorage.getItem("accessToken"),
      "Cache-control"               : "no-cache, no-store, must-revalidate", //ie11 cache ajax
      "Pragma"                      : "no-cache",
      "Expires"                     : "0",
      "wbDate"                      : api.buildNumber+"/"+api.buildDateAPI,
      "wbEnv"                       : api.webappENV,
    }
  };
  if(api.use_uph){
    config.headers.username = getVoucherUser(api.url);
    config.headers.password = getVoucherData(api.url);
  }
  // const data = "<?xml version=\"1.0\" encoding=\"UTF-8\"?>"+
  // "<reqFinalizeOutbound>"+
  //    "<centralID>"+reqData.centralID+"</centralID>"+
  // "</reqFinalizeOutbound>";
  const data = {
    "saveCard"       : reqData.saveCard===true ? 1 : 0,
    "centralID"      : reqData.centralID,
    "cardHolderName" : reqData.cardHolderName
  };
  if(api.print_HTTP_URL){console.log(methName+localUrl);}
  return axios
    .post(localUrl, data, config)
    .then(handleResponse)
    .then(resData => {
      if(api.print_HTTP_RESP_BODY){console.log(resData);}
      return resData;
    })
    .catch(err => {
      //-------------
      //token refresh
      //-------------
      //if(err.httpCode===401){
      if(err.message==="Request failed with status code 401"){
        const refreshUrl  = api.url + "/wbrestservices-1.0.0/wbservice/refresh";
        const refreshData = {"accessToken":localStorage.getItem("accessToken"), "refreshToken":localStorage.getItem("refreshToken") };
        return axios
          .post(refreshUrl, refreshData, config)
          .then(handleResponse)
          .then(resData => {
            if(api.print_HTTP_RESP_BODY){console.log(resData);}
            localStorage.setItem("accessToken_RetrieveLastDate", new Date());
            localStorage.setItem("accessToken",  resData.accessToken);
            config.headers["Authorization"] = "Bearer "+ localStorage.getItem("accessToken");
            //--------------
            //repeat request
            //--------------
            return axios
              .post(localUrl, data, config)
              .then(handleResponse)
              .then(resData => {
                if(api.print_HTTP_RESP_BODY){console.log(resData);}
                return resData;
              })
              .catch(err => {
                return Promise.reject(err);
              });
          })
          .catch(err => {
            return Promise.reject(err);
          });
      }
      else{
        return Promise.reject(err);
      }
    });
}
//----------------------------------------------------------------------------------------------------
function wu_cardpaymentpay(reqData) {
  const methName = "wu_cardpaymentpay ";
  var localUrl = api.url + "/wbrestservices-1.0.0/wbservice/cardpaymentpay";

  if(localStorage.getItem("HTTP_user")==='nikos.menis.600@veriah.com'){ //blabla14
  //localUrl = "https://demosdp.veriah.net/channel/test.php";
  //localUrl = api.url + "/wbrestservices-1.0.0/wbservice/timeout";
    localUrl = api.url + "/wbrestservices-1.0.0/wbservice/timeoutTomcat";
  }

  const config = {
    timeout: api.netTimeout_large,
    headers: {
      "Content-Type"                : "application/json",//"application/xml",
      "Accept"                      : "application/json",
    //"username"                    : getVoucherUser(api.url),//api.username,
    //"password"                    : getVoucherData(api.url),//api.password,
      "appType"                     : api.appType,
      "appId"                       : getAppId(api.appId),//api.appId,
      "platform"                    : api.platform,
      "channel"                     : api.platformWeb,
    //"appStats"                    : getAppStats(api.webappENV),
    //"webServiceCount"             : getWebServiceCount(),
      "appVersion"                  : api.appVersion,
      "apiVersion"                  : api.apiVersion,
      "lang"                        : localStorage.getItem("lang"),
      "Access-Control-Allow-Origin" : api.allowOrigin_val,
      "tokenID"                     : localStorage.getItem("tokenID"),
      "Authorization"               : "Bearer "+ localStorage.getItem("accessToken"),
      "Cache-control"               : "no-cache, no-store, must-revalidate", //ie11 cache ajax
      "Pragma"                      : "no-cache",
      "Expires"                     : "0",
      "wbDate"                      : api.buildNumber+"/"+api.buildDateAPI,
      "wbEnv"                       : api.webappENV,
    }
  };
  if(api.use_uph){
    config.headers.username = getVoucherUser(api.url);
    config.headers.password = getVoucherData(api.url);
  }
  // const data = "<?xml version=\"1.0\" encoding=\"UTF-8\"?>"+
  // "<reqFinalizeOutbound>"+
  //    "<centralID>"+reqData.centralID+"</centralID>"+
  // "</reqFinalizeOutbound>";
  var data = {
    "centralID"    : reqData.centralID,
    "token"        : reqData.token,
    "screenWidth"  : reqData.screenWidth,
    "screenHeight" : reqData.screenHeight,
    "timezone"     : reqData.timezone,
  };
  if(localStorage.getItem("HTTP_user")==='nikos.menis.600@veriah.com'){
    data = {};
  }
  if(api.print_HTTP_URL){console.log(methName+localUrl);}
  return axios
    .post(localUrl, data, config)
    .then(handleResponse)
    .then(resData => {
      if(api.print_HTTP_RESP_BODY){console.log(resData);}
      return resData;
    })
    .catch(err => {
      //-------------
      //token refresh
      //-------------
      //if(err.httpCode===401){
      if(err.message==="Request failed with status code 401"){
        const refreshUrl  = api.url + "/wbrestservices-1.0.0/wbservice/refresh";
        const refreshData = {"accessToken":localStorage.getItem("accessToken"), "refreshToken":localStorage.getItem("refreshToken") };
        return axios
          .post(refreshUrl, refreshData, config)
          .then(handleResponse)
          .then(resData => {
            if(api.print_HTTP_RESP_BODY){console.log(resData);}
            localStorage.setItem("accessToken_RetrieveLastDate", new Date());
            localStorage.setItem("accessToken",  resData.accessToken);
            config.headers["Authorization"] = "Bearer "+ localStorage.getItem("accessToken");
            //--------------
            //repeat request
            //--------------
            return axios
              .post(localUrl, data, config)
              .then(handleResponse)
              .then(resData => {
                if(api.print_HTTP_RESP_BODY){console.log(resData);}
                return resData;
              })
              .catch(err => {
                return Promise.reject(err);
              });
          })
          .catch(err => {
            return Promise.reject(err);
          });
      }
      else{
        return Promise.reject(err);
      }
    });
}
//----------------------------------------------------------------------------------------------------
function wu_cardpaymentpayBP(reqData) {
  const methName = "wu_cardpaymentpayBP ";
  var localUrl = api.url + "/wbrestservices-1.0.0/wbservice/cardpaymentpayBP";

  if(localStorage.getItem("HTTP_user")==='nikos.menis.600@veriah.com'){ //blabla14
  //localUrl = "https://demosdp.veriah.net/channel/test.php";
  //localUrl = api.url + "/wbrestservices-1.0.0/wbservice/timeout";
    localUrl = api.url + "/wbrestservices-1.0.0/wbservice/timeoutTomcat";
  }

  const config = {
    timeout: api.netTimeout_large,
    headers: {
      "Content-Type"                : "application/json",//"application/xml",
      "Accept"                      : "application/json",
    //"username"                    : getVoucherUser(api.url),//api.username,
    //"password"                    : getVoucherData(api.url),//api.password,
      "appType"                     : api.appType,
      "appId"                       : getAppId(api.appId),//api.appId,
      "platform"                    : api.platform,
      "channel"                     : api.platformWeb,
    //"appStats"                    : getAppStats(api.webappENV),
    //"webServiceCount"             : getWebServiceCount(),
      "appVersion"                  : api.appVersion,
      "apiVersion"                  : api.apiVersion,
      "lang"                        : localStorage.getItem("lang"),
      "Access-Control-Allow-Origin" : api.allowOrigin_val,
      "tokenID"                     : localStorage.getItem("tokenID"),
      "Authorization"               : "Bearer "+ localStorage.getItem("accessToken"),
      "Cache-control"               : "no-cache, no-store, must-revalidate", //ie11 cache ajax
      "Pragma"                      : "no-cache",
      "Expires"                     : "0",
      "wbDate"                      : api.buildNumber+"/"+api.buildDateAPI,
      "wbEnv"                       : api.webappENV,
    }
  };
  if(api.use_uph){
    config.headers.username = getVoucherUser(api.url);
    config.headers.password = getVoucherData(api.url);
  }
  // const data = "<?xml version=\"1.0\" encoding=\"UTF-8\"?>"+
  // "<reqFinalizeOutbound>"+
  //    "<centralID>"+reqData.centralID+"</centralID>"+
  // "</reqFinalizeOutbound>";
  var data = reqData;

  if(localStorage.getItem("HTTP_user")==='nikos.menis.600@veriah.com'){
    data = {};
    if(api.print_HTTP_URL){console.log(methName+localUrl);}
    return axios
      .get(localUrl, config)
      .then(handleResponse)
      .then(resData => {
        if(api.print_HTTP_RESP_BODY){console.log(resData);}
        return resData;
      })
      .catch(err => {
        //-------------
        //token refresh
        //-------------
        //if(err.httpCode===401){
        if(err.message==="Request failed with status code 401"){
          const refreshUrl  = api.url + "/wbrestservices-1.0.0/wbservice/refresh";
          const refreshData = {"accessToken":localStorage.getItem("accessToken"), "refreshToken":localStorage.getItem("refreshToken") };
          return axios
            .post(refreshUrl, refreshData, config)
            .then(handleResponse)
            .then(resData => {
              if(api.print_HTTP_RESP_BODY){console.log(resData);}
              localStorage.setItem("accessToken_RetrieveLastDate", new Date());
              localStorage.setItem("accessToken",  resData.accessToken);
              config.headers["Authorization"] = "Bearer "+ localStorage.getItem("accessToken");
              //--------------
              //repeat request
              //--------------
              return axios
                .post(localUrl, data, config)
                .then(handleResponse)
                .then(resData => {
                  if(api.print_HTTP_RESP_BODY){console.log(resData);}
                  return resData;
                })
                .catch(err => {
                  return Promise.reject(err);
                });
            })
            .catch(err => {
              return Promise.reject(err);
            });
        }
        else{
          return Promise.reject(err);
        }
      });
  }
  else{
    data = reqData;
    if(api.print_HTTP_URL){console.log(methName+localUrl);}
    return axios
      .post(localUrl, data, config)
      .then(handleResponse)
      .then(resData => {
        if(api.print_HTTP_RESP_BODY){console.log(resData);}
        return resData;
      })
      .catch(err => {
        //-------------
        //token refresh
        //-------------
        //if(err.httpCode===401){
        if(err.message==="Request failed with status code 401"){
          const refreshUrl  = api.url + "/wbrestservices-1.0.0/wbservice/refresh";
          const refreshData = {"accessToken":localStorage.getItem("accessToken"), "refreshToken":localStorage.getItem("refreshToken") };
          return axios
            .post(refreshUrl, refreshData, config)
            .then(handleResponse)
            .then(resData => {
              if(api.print_HTTP_RESP_BODY){console.log(resData);}
              localStorage.setItem("accessToken_RetrieveLastDate", new Date());
              localStorage.setItem("accessToken",  resData.accessToken);
              config.headers["Authorization"] = "Bearer "+ localStorage.getItem("accessToken");
              //--------------
              //repeat request
              //--------------
              return axios
                .post(localUrl, data, config)
                .then(handleResponse)
                .then(resData => {
                  if(api.print_HTTP_RESP_BODY){console.log(resData);}
                  return resData;
                })
                .catch(err => {
                  return Promise.reject(err);
                });
            })
            .catch(err => {
              return Promise.reject(err);
            });
        }
        else{
          return Promise.reject(err);
        }
      });
  }
}
//----------------------------------------------------------------------------------------------------
